export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'goodsList',
      tableVisible: false,
      tableReload: true
    }
  },
  mounted() {
    this.columns()
  },
  methods: {
    // 权限过滤配置
    getPermissionColumnsToFilter() {
      return [
        { columnName: 'skuPromotionName', permission: 'ec-pc-new#ec-pc-new#skuList#promotionName' }, // SKU推广名称
        { columnName: 'containsPine', permission: 'ec-pc-new#ec-pc-new#skuList#isPine' } // 是否含松木
      ]
    },
    // 根据权限过滤列
    filterByPermission(data) {
      const permitList = JSON.parse(localStorage.getItem('permitList') || '[]')
      const permissionColumnsToFilter = this.getPermissionColumnsToFilter()
      return data.filter(v => {
        const columnConfig = permissionColumnsToFilter.find(item => item.columnName === v.columnName)
        if (columnConfig) {
          return permitList.includes(columnConfig.permission)
        }
        return true
      })
    },
    columns(type) {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.columnsData = res.data
        let data = res.data.userColumns.length ? res.data.userColumns : res.data.sysColumns
        
        // 根据权限过滤列
        data = this.filterByPermission(data)
        
        let list = []
        data.forEach(v => {
          list.push({
            displayName: v.displayName,
            displayWidth: v.displayWidthNum,
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.columnName
          })
        });
        this.tableDataSet = list
        if(!type) {
          this.customColumn(this.columnsData)
        }
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns(true)
    },
    confirm() {
      let data = []
      console.log(this.tableDataSet);
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: v.displayWidth,
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
    async customColumn(data) {
      if (data.userColumns.length) {
        data = data.userColumns.filter(v=>!v.isShow)
      } else {
        data = data.sysColumns
      }
      
      // 根据权限过滤列
      data = this.filterByPermission(data)
      
      this.columnData = []
      data.forEach(v => {
        this.columnData.push({
          label: v.displayName,
          prop: v.columnName,
          width: v.displayWidth,
          sortable: v.sortable == '1' ? "custom" : false,
          span: false,
          fixed: v.freezeType,
        })
      })
    }
  }
}